import React, { useEffect, useState } from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';

/**
 * Sticky bottom CTA that appears once the visitor scrolls past the hero CTA.
 */
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const trigger = document.getElementById('hero-cta');
    if (!trigger) return;
    const observer = new IntersectionObserver(([entry]) => {
      setVisible(entry.boundingClientRect.top < 0 && !entry.isIntersecting);
    }, {
      threshold: 0
    });
    observer.observe(trigger);
    return () => observer.disconnect();
  }, []);
  return <div className={`fixed inset-x-0 bottom-0 z-40 px-3 pb-3 transition-[opacity,transform] duration-200 ease-out ${visible ? 'pointer-events-auto translate-y-0 opacity-100' : 'pointer-events-none translate-y-6 opacity-0'}`} data-id="element-124" data-mp="bqsmvdns4g0j">
      <div className="mx-auto max-w-md rounded-2xl bg-navy/95 p-2 shadow-2xl shadow-black/30 backdrop-blur sm:max-w-lg" data-id="element-125" data-mp="14ddemf862u4m">
        <a href={CHECKOUT_URL} className={`flex items-center justify-center gap-2 rounded-xl bg-cta px-4 py-3.5 text-[14px] font-extrabold uppercase tracking-wide text-white transition-colors duration-200 ease-out hover:bg-ctahover focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white sm:text-base ${visible ? 'animate-shake' : ''}`} data-id="element-126" data-mp="2f410sdpz51r8">
          Get the Blueprint — $27
          <ArrowRightIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-127" data-mp="1weucmb6evhy1" />
        </a>
        <p className="pt-1.5 text-center text-[10.5px] font-semibold uppercase tracking-wide text-white/70" data-id="element-128" data-mp="1ifcmnshdpyn3">
          Instant access · Automatic currency conversion
        </p>
      </div>
    </div>;
}